import React from "react";
import { Filetree } from "../datastructure";

interface Props {
  filetree: Filetree;
  children: React.ReactNode;
}

/**
 * Shows a loading spinner while the tree root is loading,
 * then renders children once loaded.
 */
export function TreeLoadingWrapper({ filetree, children }: Props) {
  const isLoading =
    filetree.isReloading(filetree.root) && !filetree.isLoaded(filetree.root);

  if (isLoading) {
    return (
      <div className="flex flex-col items-center justify-center h-full min-h-[200px] w-full gap-3 text-gray-500 py-12">
        <div className="animate-spin w-6 h-6 border-2 border-gray-300 border-t-blue-600 rounded-full" />
        <span className="text-sm">Loading files...</span>
      </div>
    );
  }

  return <>{children}</>;
}
